"use strict";
exports.__esModule = true;
exports.assignCustomerDdaRoute = exports.cancelSetupIntent = exports.createSetupIntent = exports.getCardsRoute = exports.getDefaultCardRoute = exports.addStripePaymentRoute = void 0;
var baseRoute = 'v1/wallet/customer';
var addStripePaymentRoute = function (customerId, stripePaymentId) {
    return "".concat(baseRoute, "/card/").concat(customerId, "?stripe_payment_method_id=").concat(stripePaymentId);
};
exports.addStripePaymentRoute = addStripePaymentRoute;
var getDefaultCardRoute = function (customerId) { return "".concat(baseRoute, "/card/").concat(customerId); };
exports.getDefaultCardRoute = getDefaultCardRoute;
var getCardsRoute = function (customerId) { return "".concat(baseRoute, "/cards/").concat(customerId); };
exports.getCardsRoute = getCardsRoute;
var createSetupIntent = function (customerId, stripePaymentId) {
    return "".concat(baseRoute, "/card/").concat(customerId, "/setup?stripe_payment_method_id=").concat(stripePaymentId);
};
exports.createSetupIntent = createSetupIntent;
var cancelSetupIntent = function (customerId, stripeSetupIntentId) {
    return "".concat(baseRoute, "/card/").concat(customerId, "/setup?stripe_setup_intent_id=").concat(stripeSetupIntentId);
};
exports.cancelSetupIntent = cancelSetupIntent;
var assignCustomerDdaRoute = function (customerId) { return "".concat(baseRoute, "/dda/").concat(customerId, "/assign"); };
exports.assignCustomerDdaRoute = assignCustomerDdaRoute;
